import { newTherapyTemplateAction } from 'src/redux/actions/constant';

const {
  DELETE_THERAPY_TEMPLATE_RESET,
  DELETE_THERAPY_TEMPLATE_FAILURE,
  DELETE_THERAPY_TEMPLATE_LOADING,
  DELETE_THERAPY_TEMPLATE_SUCCESS,
} = newTherapyTemplateAction;

const initialstate: object = {
  response: null,
  loading: false,
};

export const deleteTherapyTemplateReducer = (state = initialstate, action: any) => {
  switch (action.type) {
    case DELETE_THERAPY_TEMPLATE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
      };
    }

    case DELETE_THERAPY_TEMPLATE_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
      };

    case DELETE_THERAPY_TEMPLATE_LOADING:
      return {
        ...state,
        loading: true,
      };

    case DELETE_THERAPY_TEMPLATE_RESET:
      return initialstate;

    default:
      return state;
  }
};
